import React, { useState } from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import PropTypes from "prop-types";

import Typography from "../Typography/Typography";
import ModalActions from "../modal/ModalActions";
import Checkbox from "../Checkbox/Checkbox";
import { modalMessageClassName } from "../modal/Modal.constants";

import { useModalContext } from "../../contexts/modal";

import styles from "./ToggleInLibraryDialog.module.scss";

const ToggleInLibraryDialog = ({ isRemoveCoupleBooks, message, onConfirm }) => {
  const { t } = useSharedTranslation();

  const { hideDialog } = useModalContext();

  const [doNotAskAgain, setDoNotAskAgain] = useState(false);
  return (
    <div className={styles["root"]}>
      <Typography variant="body2" className={modalMessageClassName}>{message}</Typography>
      {
        !isRemoveCoupleBooks && (
          <Checkbox
            className={styles["checkbox"]}
            title={t("doNotAskAgain")}
            checked={doNotAskAgain}
            onChange={() => {
              setDoNotAskAgain(!doNotAskAgain);
            }}
          />
        )
      }
      <ModalActions onClickNegative={hideDialog} onClickPositive={() => {
        onConfirm(doNotAskAgain);
        hideDialog();
      }} />
    </div>
  );
};

ToggleInLibraryDialog.propTypes = {
  message: PropTypes.string,
  onConfirm: PropTypes.func
};

export default ToggleInLibraryDialog;
